export default function FeaturesBanner() {
  const features = [
    { icon: 'ri-flashlight-line', title: '流畅不缓冲', desc: '先进的流媒体传输技术，自适应码率智能切换，确保高清视频流畅播放不卡顿' },
    { icon: 'ri-smartphone-line', title: '多端兼容', desc: '支持手机、平板、电脑全平台播放，无需下载任何客户端或插件，打开网页即看' },
    { icon: 'ri-vidicon-line', title: '海量资源', desc: '涵盖蜜桃视频、红桃视频、樱桃视频等内容分类，最新影视剧集实时更新' },
    { icon: 'ri-shield-check-line', title: '安全可靠', desc: '正规内容授权，绿色安全无广告插件，为您提供安心舒适的观影环境' },
  ];

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-50" aria-labelledby="features-heading">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 id="features-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择西瓜视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为用户提供最佳的在线视频观看体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl bg-background-100 border border-background-200/70 text-center transition-all duration-300 hover:scale-[1.02]"
            >
              <div className={`w-14 h-14 mx-auto rounded-xl flex items-center justify-center mb-4 transition-transform duration-300 group-hover:scale-110 ${
                index % 2 === 0 ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-700'
              }`}>
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-2 text-base">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}